export const expertTheme = {
  colors: {
    canvas: '#f4f0e8',
    canvasSoft: '#faf8f3',
    surface: '#ffffff',
    ink: '#20211d',
    inkSoft: '#5f625a',
    line: '#ded9cf',
    accent: '#f06432',
    accentDark: '#ce4720',
    sage: '#697d54',
    sageSoft: '#e5eadc',
    charcoal: '#262824',
  },
  radius: {
    small: '12px',
    medium: '20px',
    large: '30px',
    pill: '999px',
  },
  shadow: {
    soft: '0 18px 55px rgba(42, 38, 30, 0.08)',
    hover: '0 22px 60px rgba(42, 38, 30, 0.14)',
  },
  container: '1240px',
};

export const focusRing = `
  &:focus-visible {
    outline: 3px solid rgba(240, 100, 50, 0.32);
    outline-offset: 3px;
  }
`;

export const reducedMotion = `
  @media (prefers-reduced-motion: reduce) {
    transition: none;
    animation: none;
  }
`;
